import React from "react";
import classes from "./index.module.scss";

export function LeftContentInvoicesList(props: {
  customerName: string;
  policyNumber: string;
}) {
  return (
    <section className={classes.wrapper}>
      <div>
        <div className={classes.firstTitle}>
          <strong>Danh sách</strong>
        </div>
        <div className={classes.secondTitle}>hoá đơn điện tử</div>
        <p>
          Hợp đồng số: <b>{props.policyNumber}</b>
        </p>
        <p>
          Chủ hợp đồng: <b>{props.customerName}</b>
        </p>
      </div>
    </section>
  );
}
